import(/* webpackMode: "eager" */ "/workspace/web-admin/node_modules/next/dist/client/link.js");
